export default __webpack_public_path__ + "static/media/britain_flag.0affdc90.png";